var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4238 4.57581C17.6581 4.81015 17.6581 5.19005 17.4237 5.42434L7.42138 15.4243C7.30884 15.5369 7.1562 15.6001 6.99705 15.6C6.83791 15.6 6.68529 15.5367 6.57279 15.4242L2.17513 11.0242C1.94088 10.7898 1.94098 10.4099 2.17536 10.1756C2.40974 9.94139 2.78964 9.9415 3.02389 10.1759L6.99733 14.1514L16.5753 4.57571C16.8096 4.34142 17.1895 4.34147 17.4238 4.57581Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmall);
export default __webpack_public_path__ + "static/media/check-small.4adee617c811b1512bac104953e2d8d7.svg";
export { ForwardRef as ReactComponent };